import { useState } from 'react';
import { Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';

import SEO from '../../../src/components/SEO';
import Post from '../../../src/components/dcard/Post';
import NavBar from '../../../src/components/NavBar';
import { selectFirebaseAuthed, selectFirebaseAuthIsLoaded } from '../../../src/selectors';

const DcardPost = (props: any) => {
  const [seo, setSeo] = useState({
    title: '',
    description: '',
  });
  const router = useRouter();
  const { pid } = router.query;

  const {
    authIsLoaded,
    authed,
  } = props;

  return (
    <>
      <SEO title={seo.title} description={seo.description} />
      <NavBar isFetching={!authIsLoaded} authed={authed} export>
        {!authIsLoaded ? (
          <Loader active inline="centered" />
        ) : (
          <Post authed={authed} id={pid} setSeo={setSeo} />
        )}
      </NavBar>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  authIsLoaded: selectFirebaseAuthIsLoaded(state),
  authed: selectFirebaseAuthed(state),
});

export default connect(mapStateToProps)(DcardPost);
